import { render, staticRenderFns } from "./SearchBrand.vue?vue&type=template&id=17aaf7d1&"
import script from "./SearchBrand.vue?vue&type=script&lang=ts&"
export * from "./SearchBrand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports